import { getCSRFHeaders, getJSON, postJSON } from '@folklore/fetch';
import queryString from 'query-string';

class Base {
    baseUrl: string | null;
    isBot: boolean;

    constructor(opts) {
        const { baseUrl = null, isBot = false } = opts || {};

        this.baseUrl = baseUrl;
        this.isBot = isBot;
    }

    getJSONWithSession<Response>(path: string, query = null, opts?: RequestInit) {
        const { headers } = opts || {};
        return this.getJSON<Response>(path, query, {
            ...opts,
            credentials: 'include',
            headers: {
                ...(typeof window !== 'undefined' ? getCSRFHeaders() : null),
                ...headers,
            },
        });
    }

    postJSONWithSession<Response>(path: string, data = null, opts?: RequestInit) {
        const { headers } = opts || {};
        return this.postJSON<Response>(path, data, {
            ...opts,
            credentials: 'include',
            headers: {
                ...(typeof window !== 'undefined' ? getCSRFHeaders() : null),
                ...headers,
            },
        });
    }

    getJSON<Response>(path: string, query = null, opts?: RequestInit): Promise<Response> {
        return getJSON<Response>(
            `${this.getFullUrl(path)}${
                query !== null
                    ? `?${queryString.stringify(query, {
                          arrayFormat: 'bracket',
                          skipNull: true,
                      })}`
                    : ''
            }`,
            opts,
        );
    }

    postJSON<Response>(path: string, data = null, opts?: RequestInit): Promise<Response> {
        return postJSON<Response>(this.getFullUrl(path), data, opts);
    }

    getFullUrl(path: string): string {
        return `${this.baseUrl || ''}${path}`;
    }
}

export default Base;
